export const BUILD_YOUR_TARGET_PATH = 'build-your-target';

export const APP_ROUTES = {
  Home: '/',

  AcceptTerms: '/accept-terms',
  ProfileWorkType: '/profile-work-type',

  CareerPlanning: {
    Base: '/career-planning',
    QuickMatch: '/career-planning/quick-match',
    BuildTarget: `/career-planning/${BUILD_YOUR_TARGET_PATH}`,
    /*
     * 03-skills-survey. Every "Take Skills Survey" call to action reads this,
     * and it pointed at the old wizard step, so the redesigned survey at
     * /skills-survey was unreachable from anywhere in the product: the only
     * way to it was typing the URL.
     *
     * The three other surveys keep their wizard paths. This one is redesigned
     * and they are not, so they are deliberately not moved together.
     */
    SkillsSurvey: '/skills-survey',
    InterestsSurvey: `/career-planning/${BUILD_YOUR_TARGET_PATH}/interests`,
    ValuesSurvey: `/career-planning/${BUILD_YOUR_TARGET_PATH}/values`,
    LifestyleSurvey: `/career-planning/${BUILD_YOUR_TARGET_PATH}/lifestyle`
  },

  GoalsReport: '/goals-report',

  // PWS 4.1.10 and 4.1.19. Spec 06 and 07.
  Transition: '/transition',
  PublicPage: '/p',
  SharedReport: '/shared-report',

  Account: {
    Base: '/account',
    ForgotPassword: '/account/forgot-password',
    Login: '/account/login',
    CreateAccount: '/account/create-account',
    SelectDashboard: '/account/select-dashboard'
  },

  Analytics: '/analytics',

  Error: '/error',
  ReturnSession: '/returnsession',

  About: {
    Base: '/about',
    SystemStatus: '/about/system-status',
    PrivacyPolicy: '/about/privacy',
    TermsOfUse: '/about/terms-of-use',
    Resources: '/about/resources',
    DataSources: '/about/data-sources',
    News: '/about/news',
    // WCAG 2.4.5 (Multiple Ways), technique G63.
    SiteMap: '/about/site-map'
  },

  Manager: {
    Base: '/manager',
    AllMembers: '/manager/all-members',
    Status: '/manager/status',
    Issues: '/manager/issues',
    Feedback: '/manager/submitted-feedback'
  },

  Occupation: '/occupation',
  Pathway: '/pathway',
  Passcode: '/passcode'
};

/**
 * The pages that render the Career Pathways and Occupation Matches bands.
 *
 * Both bands' load effects guard on the URL so their queries do not fire on
 * every page. That guard named only Build Your Target, so when the redesigned
 * home page became the landing page both bands rendered with nothing to
 * render: a signed-in member saw an empty Career Pathways and an Occupation
 * Matches band explaining itself as empty. Cards appeared only for someone who
 * had earlier visited Build Your Target and still had them in the store, which
 * is what made it look intermittent.
 *
 * One predicate, shared, so the next page that shows these bands is added in
 * one place rather than in each effect.
 */
export const showsPathwaysAndMatches = (url: string): boolean =>
  // /home is kept only as a redirect to the line above, but it is still worth
  // matching: the guard runs during the navigation, before the redirect has
  // resolved, and a band that misses its own load stays empty.
  url.includes(APP_ROUTES.CareerPlanning.BuildTarget) || url.startsWith('/home');
